import { FactoringCompany } from '@store/carriers';

export const FACTORING_COMPANY_INITIAL_OBJECT: FactoringCompany = {
  operationType: 'None',
  id: 0,
  createdDate: null,
  modifiedDate: null,
  name: '',
  taxId: null,
  needs1099: false,
  vendorHold: false,
  physicalAddress1: null,
  physicalAddress2: null,
  physicalCity: null,
  physicalState: null,
  physicalCountryCode: null,
  physicalZip: null,
  remitTo: '',
  mailingAddress1: null,
  mailingAddress2: null,
  mailingCity: null,
  mailingState: null,
  mailingCountryCode: null,
  mailingZip: null,
  billingTerms: '',
  status: 'Pending',
  userName: null,
  password: null,
  accountingSysId: null,
  achAccount: null,
  achRouting: null,
  primaryContact: {
    verificationStatus: 0,
    emailVerified: false,
    phoneVerified: false,
    id: 0,
    objectId: 0,
    objectType: null,
    name: '',
    phone1: null,
    extension1: null,
    phone2: null,
    extension2: null,
    fax: null,
    email: null,
    type: null,
    status: null,
    createdDate: null,
    modifiedDate: null,
    mailerEmails: false,
    password: null,
    userName: null,
    createdBy: null,
    modifiedBy: null,
    phone: null,
    verifiedDisabled: null,
    ownershipSource: null,
    operationType: 'None',
  },
  carriers: [],
  isCarrierExist: false,
  comments: [],
  contacts: null,
  numberOfCarriers: 0,
};

export const FactoringCompanyStatuses = [
  'Active',
  'Inactive',
  'Pending',
  'Out of Business',
  'Unvetted',
];

export const FactoringCompanyBillingTerms = [
  'Due Upon Receipt',
  'Net 30',
  'Net 45',
  'Net 60',
];
